import { Controller } from '@hotwired/stimulus';
import { translate } from '../../utils/translation';
import { debounce } from '../../utils/debounce';

export default class AfsuFormController extends Controller {
  static targets = [
    'counter',
    'selectAllUsedVehiclesCheckbox',
    'selectAllNewVehiclesCheckbox',
    'usedVehiclesCheckbox',
    'newVehiclesCheckbox',
  ];
  static values = {
    adsCountUrl: String,
  };
  static DEBOUNCE_DELAY = 500;

  connect() {
    this.debouncedUpdate = debounce(this.updateCount, this.constructor.DEBOUNCE_DELAY);
    this.element.addEventListener('input', this.debouncedUpdate);
    this.element.addEventListener('change', this.debouncedUpdate);

    if (this.hasUsedVehiclesCheckboxTarget && this.hasSelectAllUsedVehiclesCheckboxTarget) {
      this.syncSelectAllCheckbox(this.usedVehiclesCheckboxTargets, this.selectAllUsedVehiclesCheckboxTarget);
    }
    if (this.hasNewVehiclesCheckboxTarget && this.hasSelectAllNewVehiclesCheckboxTarget) {
      this.syncSelectAllCheckbox(this.newVehiclesCheckboxTargets, this.selectAllNewVehiclesCheckboxTarget);
    }
  }

  disconnect() {
    this.element.removeEventListener('input', this.debouncedUpdate);
    this.element.removeEventListener('change', this.debouncedUpdate);
  }

  onCheckboxChange(event) {
    const changedCheckbox = event.target;
    if (
      this.usedVehiclesCheckboxTargets &&
      this.usedVehiclesCheckboxTargets.includes(changedCheckbox) &&
      this.selectAllUsedVehiclesCheckboxTarget
    ) {
      this.syncSelectAllCheckbox(this.usedVehiclesCheckboxTargets, this.selectAllUsedVehiclesCheckboxTarget);
    } else if (
      this.newVehiclesCheckboxTargets &&
      this.newVehiclesCheckboxTargets.includes(changedCheckbox) &&
      this.selectAllNewVehiclesCheckboxTarget
    ) {
      this.syncSelectAllCheckbox(this.newVehiclesCheckboxTargets, this.selectAllNewVehiclesCheckboxTarget);
    }
    this.updateCount();
  }

  toggleCheckboxGroup(group, checked) {
    group.forEach((checkbox) => {
      checkbox.checked = checked;
    });
    this.updateCount();
  }

  toggleUsedVehicles(event) {
    this.toggleCheckboxGroup(this.usedVehiclesCheckboxTargets, event.target.checked);
  }

  toggleNewVehicles(event) {
    this.toggleCheckboxGroup(this.newVehiclesCheckboxTargets, event.target.checked);
  }

  syncSelectAllCheckbox(groupTargets, selectAllTarget) {
    selectAllTarget.checked = groupTargets.length > 0 && groupTargets.every((cb) => cb.checked);
  }

  updateCount = () => {
    const form = this.element;
    const formData = new FormData(form);
    const data = {};

    formData.forEach((value, key) => {
      if (data[key]) {
        if (Array.isArray(data[key])) {
          data[key].push(value);
        } else {
          data[key] = [data[key], value];
        }
      } else {
        data[key] = value;
      }
    });

    if (data.usedVehiclePartners && !Array.isArray(data.usedVehiclePartners)) {
      data.usedVehiclePartners = [data.usedVehiclePartners];
    }

    const params = new URLSearchParams();
    Object.entries(data).forEach(([key, value]) => {
      if (Array.isArray(value)) {
        value.forEach((v) => {
          params.append(key.endsWith('[]') ? key : key + '[]', v);
        });
      } else {
        params.append(key, value);
      }
    });

    fetch(this.adsCountUrlValue, {
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: params,
    })
      .then((response) => response.json())
      .then((json) => {
        if (this.hasCounterTarget && json.count !== undefined) {
          this.counterTarget.textContent = translate('common.search_form.filter_button', { count: json.count });
        }
      })
      .catch(() => {});
  };
}
